import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const IconContainer = styled.div`
  margin-bottom: 24px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 8px;
`;

export const SubtitleContainer = styled.div`
  text-align: center;
`;

